<script lang="ts">
	/**
	 * Docs layout - Standalone layout without marketing header/footer.
	 * This completely replaces the root layout for all /docs routes.
	 */
	import '../../app.css';

	let { children } = $props();
</script>

{@render children()}
